import { createContext } from 'react';

const CHContext = createContext();

export default CHContext;
